"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconColors = exports.VariantSize = exports.VariantColor = exports.ListSize = exports.IconSize = exports.IconColor = void 0;
var _palette = _interopRequireDefault(require("@telus-uds/palette-allium/build/web/palette"));
var _RichTextPropTypes = require("./RichTextPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var VariantColor = exports.VariantColor = ['default', 'brand', 'dark', 'light', 'positive', 'warning', 'danger', 'black', 'white', 'brand2', 'brand3', 'alternative1', 'alternative2', 'alternative3'];
var VariantSize = exports.VariantSize = ['micro', 'small', 'large', 'eyebrow', 'display1', 'display2', ..._RichTextPropTypes.headingSizes];
var IconColor = exports.IconColor = ['purpleTelus', 'greyCharcoal', 'greyShuttle', 'redDark', 'amberDark', 'greenAccessible', 'white'];
var IconSize = exports.IconSize = ['small', 'medium', 'large', 'extra large'];
var ListSize = exports.ListSize = ['small', 'medium', 'large'];
var iconColors = exports.iconColors = {
  purpleTelus: _palette.default.color.purpleTelus,
  greyCharcoal: _palette.default.color.greyCharcoal,
  greyShuttle: _palette.default.color.greyShuttle,
  redDark: _palette.default.color.redDark,
  amberDark: _palette.default.color.amberDark,
  greenAccessible: _palette.default.color.greenAccessible,
  white: _palette.default.color.white,
  undefined: _palette.default.color.purpleTelus
};